export const generateRandomNumberId = () => Math.floor(Math.random() * 10000)